import BDcoinLogo from "../Assets/BDcoin.png"

function BDcoin({ size = 14 }) {
    const dimension = `${size}px`;
    return (
        <img src={BDcoinLogo}
            alt="BD Coin"
            className="object-contain"
            style={{ width: dimension, height: dimension }}
            loading="lazy"
        />
    )
}

export default BDcoin
